import agent from "../../services/agent";
import {
    SET_USERS_LIST,
    SET_USERS_ACTIVE_SCREEN,
    SET_CLOSE_EDIT_USER_MODAL,
    SET_OPEN_EDIT_USER_MODAL,
    SET_ROLE_LIST,
    SET_IS_GET_USER_ROLE_LIST_PENDING,
    SET_IS_EDIT_ROLE_PENDING,
} from "../constants/users.constants";
import { getToken } from "../../helpers/common";
import { showSnackbarStatus } from "./snackbar.actions";

export const setUsersList = (usersList: any): Action => ({
    type: SET_USERS_LIST,
    payload: usersList,
});

export const setRoleList = (roleList: any): Action => ({
    type: SET_ROLE_LIST,
    payload: roleList,
});

export const setUserActiveScreen = (activeScreen): Action => ({
    type: SET_USERS_ACTIVE_SCREEN,
    payload: activeScreen,
});

export const setCloseEditUserModal = (): Action => ({
    type: SET_CLOSE_EDIT_USER_MODAL,
    payload: true,
});

export const setOpenEditUserModal = (): Action => ({
    type: SET_OPEN_EDIT_USER_MODAL,
    payload: true,
});

export const setIsGetUserRoleListPending = (data): Action => ({
    type: SET_IS_GET_USER_ROLE_LIST_PENDING,
    payload: data,
});

export const setIsEditUserRolePending = (data): Action => ({
    type: SET_IS_EDIT_ROLE_PENDING,
    payload: data,
});


export const getUsersList = () => (dispatch: Function) => {
    dispatch(setIsGetUserRoleListPending(true));
    getToken(dispatch).then((accessToken) => {
        agent.Users.getUsersList(accessToken)
            .then((usersList) => {
                dispatch(setUsersList(usersList && usersList.value));
                dispatch(getRoleList())
            })
            .catch((err) => {
                dispatch(setIsGetUserRoleListPending(false));
                if (err && err.response && err.response.text) {
                    dispatch(
                        showSnackbarStatus(`Unable To Get Users List, ${err && err.response && err.response.text}`)
                    );
                }
                else {
                    dispatch(showSnackbarStatus(`Something Went Wrong`));
                }
            });
    });
}

export const getRoleList = () => (dispatch: Function) => {
    dispatch(setIsGetUserRoleListPending(true));
    getToken(dispatch).then((accessToken) => {
        agent.Users.getRoleList(accessToken)
            .then((roleList) => {
                dispatch(setRoleList(roleList && roleList.value));
                dispatch(setIsGetUserRoleListPending(false));
            })
            .catch((err) => {
                dispatch(setIsGetUserRoleListPending(false));
                if (err && err.response && err.response.text) {
                    dispatch(
                        showSnackbarStatus(`Unable To Get Users List, ${err && err.response && err.response.text}`)
                    );
                }
                else {
                    dispatch(showSnackbarStatus(`Something Went Wrong`));
                }
            });
    });
}

export const editRole = (data) => (dispatch: Function) => {
    dispatch(setIsEditUserRolePending(true));
    getToken(dispatch).then((accessToken) => {
        agent.Users.editRole(accessToken, data)
            .then(() => {
                dispatch(getUsersList());
                dispatch(setIsEditUserRolePending(false));
            })
            .catch((err) => {
                if (err && err.response && err.response.text) {
                    dispatch(
                        showSnackbarStatus(`${err && err.response && err.response.text}`)
                    );
                    dispatch(setIsEditUserRolePending(false));
                }
                else {
                    dispatch(showSnackbarStatus(`Something Went Wrong`));
                }
            });
    });
}


